import React, { Component } from 'react';
import { Button, Select } from 'antd';
import { AccountTiersWrapper } from './style';
import { ACCOUNT_ICON, PERSON } from '../../config/media';

const tierList = [
    {
        name: 'Account Tier 1',
        icon: ACCOUNT_ICON.Level_1,
        link: 'Upload Graphic',
        selectValue: 1
    },
    {
        name: 'Account Tier 2',
        icon: ACCOUNT_ICON.Level_2,
        link: 'Upload Graphic',
        selectValue: 2
    },
    {
        name: 'Account Tier 3',
        icon: ACCOUNT_ICON.Level_3,
        link: 'Upload Graphic',
        selectValue: 3
    },
    {
        name: 'Account Tier 4',
        icon: ACCOUNT_ICON.Level_4,
        link: 'Upload Graphic',
        selectValue: 4
    },
    {
        name: 'Account Tier 5',
        icon: ACCOUNT_ICON.Level_5,
        link: 'Upload Graphic',
        selectValue: 5
    },
    {
        name: 'Account Tier 6',
        icon: ACCOUNT_ICON.Level_6,
        link: 'Upload Graphic',
        selectValue: 6
    },
    {
        name: 'Account Tier 7',
        icon: ACCOUNT_ICON.Level_7,
        link: 'Upload Graphic',
        selectValue: 7
    },
    {
        name: 'Account Tier 8',
        icon: ACCOUNT_ICON.Level_8,
        link: 'Upload Graphic',
        selectValue: 8
    },
    {
        name: 'Account Tier 9',
        icon: ACCOUNT_ICON.Level_9,
        link: 'Upload Graphic',
        selectValue: 9
    },
    {
        name: 'Account Tier 10',
        icon: ACCOUNT_ICON.Level_10,
        link: 'Upload Graphic',
        selectValue: 10
    },
]
const selectOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
    { label: '7', value: 7 },
    { label: '8', value: 8 },
    { label: '9', value: 9 },
    { label: '10', value: 10 },
]

class AccountTiers extends Component {
    constructor() {
        super();
        this.state = {
            selectValue: 4
        }
    }
    handleSelect = (selectValue) => {
        this.setState( { selectValue } );
    }

    render() {
        const { selectValue } = this.state;
        let list = tierList.filter(value => {
            return (value.selectValue <= selectValue);
        });

        return (
            <AccountTiersWrapper>
                <div className="content-container">
                    <div className="content-title">
                        Number of User Tier Accounts
                    </div>
                    <div className="contents">
                        Select the number of user account tiers and set the trading fees, deposit and
                        withdrawals allowed for each account tier. Rules such as completing KYC and
                        account age and volume traded can be applied to account tiers to reward your users.
                    </div>
                </div>
                <div className="select-container">
                    <img src={PERSON} alt="person" className="account-icon" />
                    <Select
                        defaultValue= {selectValue}
                        onChange={(value) => this.handleSelect(value)}
                    >
                        {selectOptions.map((option, index) => (
                            <Select.Option key={index} value={option.value}>
                                {option.label}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
                <div className="box-container file-wrapper">
                    {list.map((list, index) => {
                        return (
                            <div className="box-wrapper file-container" key={index}>
                                <div className="flex-content">
                                    <div className="tier-name">
                                        {list.name}
                                    </div>
                                    <div className="file-container-label">
                                        <img
                                            src={list.icon}
                                            alt="icon"
                                        />
                                        <label className="link">
                                            <span>Upload Graphic</span>
                                            <input
                                                type="file"
                                                onChange={this.handleChangeFile}
                                                name="LOGO_IMAGE_LIGHT"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="button-container">
                    <Button type="primary">
                        Save
                    </Button>
                </div>
                {/* <div className="footer-container">
                    <div>
                        Looking to adjust the coin limits? Click <span className="footer-link">here.</span>
                    </div>
                    <div>
                        Looking to adjust the trading pair limits? <span className="footer-link">here.</span>
                    </div>
                </div> */}
            </AccountTiersWrapper>
        )
    }
}

export default AccountTiers;